import React from 'react';
import { RouteComponentProps, withRouter } from 'react-router';

import { UserAttributesSchema, UserStorageTabs } from '../../../components';
import { Preloader, ToDashboardError } from '../../../components/ui';
import { useCurrentProject } from '../../../contexts/settings';
import { RouteParams } from '../../../routes/types';

const UserAttributes = ({ match }: RouteComponentProps): JSX.Element => {
  const { projectId } = match.params as RouteParams;

  const { currentProjectFetching, currentProject, error } = useCurrentProject(projectId);

  if (currentProjectFetching) {
    return (
      <UserStorageTabs>
        <Preloader />
      </UserStorageTabs>
    );
  }

  if (error || !currentProject) {
    return <ToDashboardError error={error} pageName="user-attributes_open" />;
  }

  return (
    <UserStorageTabs>
      <UserAttributesSchema currentProject={currentProject} />
    </UserStorageTabs>
  );
};

export default withRouter(UserAttributes);
